import { createSelector } from 'reselect';

import { SECURITY_USER_DEFAULTS_DATA } from 'Console/data/security/constants';

const getSecurity = (state) => state.security;

export const selectUser = createSelector(
    [getSecurity],
    ({ user = SECURITY_USER_DEFAULTS_DATA }) => user
);

export const selectUserEmail = createSelector([selectUser], ({ email = '' }) => email);
